export function formatBytes(bytes, decimals = 2) {
    if (isNaN(bytes) || bytes < 0) {
        throw new Error('The bytes cannot be negative.');
    }

    if (bytes === 0) {
        return '0 Bytes';
    }

    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB'];
    let i = 0;
    let value = bytes;

    while (value >= 1024 && i < sizes.length - 1) {
        value /= 1024;
        i++;
    }

    const formattedValue = value % 1 === 0 ? value.toFixed(0) : value.toFixed(decimals);

    return `${formattedValue}${sizes[i]}`;
}
